




import type { Onderbreking } from "../../types/onderbrekingen/Onderbreking";

import Vue from "vue";
import ListItem from "../interface/ListItem.vue";

export default Vue.extend({
    name: "onderbreking-card-content",
    props: {
        onderbreking: {
            type: Object as () => Onderbreking,
            required: true
        },
    },
    components: {
        ListItem,
    },
});
